import {Component, OnInit} from '@angular/core';
import {MsgBoxService} from '../../shared/msg-box.service';
import {I18NService} from '../../i18n/i18n.service';
import {errorCode} from '../../commons/commons';
import {AuthErrorCode} from '../../api/errors';
import {LoginService} from '../../shared/login.service';
import {UserProfile} from 'auth-commons';

@Component({
    selector: 'app-change-pwd',
    templateUrl: './change-pwd.component.html',
    styleUrls: ['./change-pwd.component.scss']
})
export class ChangePwdComponent implements OnInit {

    constructor(private readonly loginService: LoginService,
                private readonly i18n: I18NService,
                private readonly msgBoxService: MsgBoxService) {
    }

    ngOnInit() {
    }

    onPwdChanged() {
    }

    onLogin(user: UserProfile) {
        this.loginService.notifyLogin(user);
    }

    onErrorOccurred(event: [string, Error]) {
        const msg = mkErrorMessage(event[1]) || event[0];
        this.msgBoxService.error(this.i18n.translate(msg), event[1]);
    }
}

function mkErrorMessage(err: Error): string {
    // NOTE: change-password call is redirected to the Authentication Server, which provides its own set of error codes
    const code = errorCode(err);
    switch (code) {
        case AuthErrorCode.WRONG_PASSWORD:
            return 'Wrong (current) password';
        case AuthErrorCode.USED_PASSWORD:
            return 'Password already used';
        case AuthErrorCode.FORBIDDEN_WORDS:
            return 'Password contains words like name, surname, username or email';
        case AuthErrorCode.PASSWORD_NOT_STRONG:
            return 'Password is not strong enough';
        default:
            return 'An error occurred while changing user password';
    }
}
